import { initFaqAccordion } from '../sections/faq';

initFaqAccordion();
